import styled from 'styled-components/macro';

export const Container = styled.div`
  width: 100%;
  max-width: 2000px;
  margin: 0 auto;
  display: flex;
  overflow: hidden;
`;
